import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

// List all companies the signed-in user belongs to (cross-tenant)
export function useCompanyListMine() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.company.listMine.queryOptions())
}

// Get current company
export function useCompanyGet() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.company.get.queryOptions())
}

// Get company with crew list
export function useCompanyGetWithCrew() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.company.getWithCrew.queryOptions())
}

// Create company
export function useCompanyCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.company.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}

// Update company
export function useCompanyUpdate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.company.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}

// Get crew list for company
export function useCompanyCrewList(options?: { includeInactive?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.company.getCrewList.queryOptions({ input: options }))
}

// Add crew to company
export function useCompanyAddCrew() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.company.addCrew.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

// Deactivate crew
export function useCompanyDeactivateCrew() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.company.deactivateCrew.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

// Reactivate crew
export function useCompanyReactivateCrew() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.company.reactivateCrew.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}
